import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { Tab } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { LabelCard } from 'legacyComponents/cards/types/label';

@withNamespaces()
@observer
export class LabelsTab extends React.Component {
  render() {
    const { app } = this.props;
    const { labels } = app;

    return (
      <Tab noShadow margin='0px auto'>
        <CardSection
          title=''
          cardApp={labels}
          CardComponent={LabelCard}
          noMarginTop
          gridColumns={3}
          gridGap='default'
        />
      </Tab>
    );
  }
}

LabelsTab.propTypes = {
  app: PropTypes.object,
  projectId: PropTypes.string,
  project: PropTypes.object,
};
